"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LOG_PREFIX = '[amp-realtime]';
var logger = {
  info: function info(message) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_console = console).info.apply(_console, ["".concat(LOG_PREFIX, " ").concat(message)].concat(args));
  },
  warn: function warn(message) {
    var _console2;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return (_console2 = console).warn.apply(_console2, ["".concat(LOG_PREFIX, " ").concat(message)].concat(args));
  },
  error: function error(message) {
    var _console3;

    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return (_console3 = console).error.apply(_console3, ["".concat(LOG_PREFIX, " ").concat(message)].concat(args));
  }
};
var _default = logger;
exports.default = _default;
//# sourceMappingURL=logger.js.map